module.exports = __webpack_public_path__ + "media/images/favicons/ms-icon-150x150-216788baeb6aee8f7c5eba5a0be652a5.png";